var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wrapper d-flex h-100" },
    [
      _c("Sidebar"),
      _vm._v(" "),
      _c(
        "div",
        {
          class: {
            largeHeader: _vm.largeHeader,
            "notification-request-bar-active":
              _vm.isNotifyShowing && !_vm.isAdmin && !_vm.notifyIgnored,
          },
          attrs: { id: "contents" },
        },
        [
          _vm.isNotifyShowing && !_vm.isAdmin && !_vm.notifyIgnored
            ? _c("NotificationPermissionAlert", {
                on: {
                  close: function ($event) {
                    _vm.isNotifyShowing = false
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.suspend
            ? _c(
                "div",
                { staticClass: "suspend-notify" },
                [
                  _c("div", [
                    _vm._v(_vm._s(_vm.$t("message.suspendedMessage"))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "router-link",
                    {
                      staticStyle: { "text-decoration": "underline" },
                      attrs: { to: { name: "billing" } },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("message.checkPaymentMethod")) +
                          "\n            "
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("Header"),
          _vm._v(" "),
          _c("router-view"),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }